import React from 'react';
import Search from '../anime/Search';
import AnimeIndex from '../anime/AnimeIndex';
import'../../App.css';

const Index = () => {
    return (
        <div>
            <Search />
            <AnimeIndex />
        </div>
    )
}

export default Index;
